import Vue from 'vue';
import App from './App.vue';
import router from './router';
// import './assets/js/public';
import './registerServiceWorker';
import ElementUI from 'element-ui';
// import VideoPlayer from 'vue-video-player';
import axios from 'axios';
import qs from 'qs';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/fonts/icon.css';
import BaiduMap from 'vue-baidu-map';
import Public from './assets/js/pubilc.vue'
// import './assets/js/lib-flexible.js'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './assets/css/element-variables.scss'
// @ts-ignore
import {getSiteName} from '@/utils/site.config';
axios.interceptors.response.use(response => {
  return response;
},error => {
  if (error.response) {
   switch (error.response.status) {
     // 返回401，清除token信息并跳转到登录页面
     case 401:
     localStorage.removeItem('token');
     router.replace({
       path: '/',
       //登录成功后跳入浏览的当前页面
       query: {redirect: router.currentRoute.fullPath}
     })
   }
   // 返回接口返回的错误信息
   return Promise.reject(error.response.data);
 }
});
router.beforeEach((to,from,next)=>{
  if(to?.meta?.title){
    document.title = to.meta.title + ' - ' + getSiteName() + '乡村群宴智慧管理平台'
  }
  // next()
  // 获取当前路由判断是否有权限，及session是否过期
  if(to.matched.some( m => m.meta.auth)){
    if(sessionStorage.getItem('userdata')==null){
      localStorage.removeItem('region');
      next({
        path: '/', // 未登录则跳转至login页面
        query: {redirect: to.fullPath} // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
         })
    }else{
      next()
    }
    // if() { // 已经登陆

    // }else{
    //   next()
    // }  // 正常跳转到你设置好的页面
  }else{
    next()
  }
})

// axios.defaults.baseURL = 'http://localhost:8769';
axios.defaults.baseURL = '/';
// axios.defaults.baseURL = 'https://zhqy.sclf.top/api';
// axios.defaults.baseURL = 'http://192.168.20.172:8769';
// axios.defaults.baseURL = 'http://192.168.20.172:8769';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.config.productionTip = false;
Vue.prototype.$Public = Public
// require('vue-video-player/node_modules/video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer)
Vue.use(Viewer);
Viewer.setDefaults({
  url: '../src/assets/img/huang.png'
});
Vue.use(ElementUI, {
  size: 'mini'
});
Vue.use(BaiduMap,{
  ak:'nH4VKeDVrGOkf7nDyPUoGhp1Hdd94NKx'		//使用申请的百度地图秘钥
})

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;


new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
